export const STAGE_NAMES = [
    'screen',
    'structure',
    'inBim360',
    'drawing2d',
];
// Map stage names to version types (inBim360 has no version)
export const STAGE_VERSION_MAP = {
    screen: 'screenVersion',
    structure: 'revitVersion', // Structure includes panel integration
    inBim360: null, // No version - just uploads to BIM360 cloud
    drawing2d: 'drawingVersion',
};
// Permissions by role for stages
export const STAGE_PERMISSIONS = {
    admin: ['screen', 'structure', 'inBim360', 'drawing2d'],
    bim_coordinator: ['inBim360'],
    engineer: ['screen', 'structure', 'inBim360', 'drawing2d'], // Can only approve/reject, not work
    '3d_modeller': ['screen', 'structure'],
    '2d_drafter': ['drawing2d'],
    customer_reviewer: ['inBim360', 'drawing2d'], // Client review stages only, approval-only role
    reviewer: [], // Can view and comment only, no stage permissions
    view_only: [], // No permissions to update any stages
};
// Engineer can only set these statuses (approval-only role)
export const ENGINEER_ALLOWED_STATUSES = ['complete', 'revision_required'];
// Customer reviewer can only set these statuses (approval-only role for client_review stages)
export const CUSTOMER_REVIEWER_ALLOWED_STATUSES = ['complete', 'revision_required'];
// Status colors for UI
export const STATUS_COLORS = {
    not_started: 'gray',
    in_progress: 'orange',
    complete: 'green',
    on_hold: 'red',
    client_review: 'blue',
    engineer_review: 'purple',
    revision_required: 'amber',
};
//# sourceMappingURL=showset.js.map